module.exports = __webpack_public_path__ + "img/id-card1.9cd6512e.svg";